import React, { useEffect, useState } from "react";
import Head from "next/head";
import Banner from "../../components/banner";
import { useIntl } from "react-intl";
import { getBlogInner_req } from "../../api/api";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
// import newChees from "../../assets/images/new-chees.jpg";
// import newBackgamon from "../../assets/images/new-backgamon.jpg";

const BlogInner = () => {
  const intl = useIntl();
  const [blogData, setBlogData] = useState(null);
  const locale = useSelector((state) => state.global.locale);
  const router = useRouter();
  const id = router?.query?.id;

  const getBlogInner = async () => {
    const response = await getBlogInner_req(id);
    setBlogData(response.data);
  };

  useEffect(() => {
    if (id) {
      getBlogInner();
    }
  }, [id, locale]);

  return (
    <>
      <Head>
        <title></title>
        <meta name="description" />
      </Head>
      <div className="blog">
        <Banner
          title={intl.messages.blog}
          currentPage={intl.messages.blog}
        />
        <div className="wrapper">
          <div className="blog-inner">
            <h3 className="title">{blogData?.post?.title}</h3>

            {/* {id == String(105) && (
              <img
                src={newChees.src}
                alt=""
              />
            )}
            {id == String(106) && (
              <img
                src={newBackgamon.src}
                alt=""
              />
            )} */}

            <img
              src={blogData?.post?.image}
              alt=""
            />

            <div
              dangerouslySetInnerHTML={{ __html: blogData?.post?.content }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogInner;
